export default {
  drawer: true,
  color: "success",
  image: "",
  loaderShow: false, 
  loaderText: null,
  loaderQueue: [],
  user: null, 
  userName: null,
  userCountry: null,
  pageNotFoundDescription: null,
  isAuthenticated: false,
  documents: [],
  errorMessageBox: {
      show: false,
      title: null,
      error: null
  },    
  messageBox: {
      show: false,
      title: null,
      text: null,
      maxWidth: "500px",
      callback: function(){ }
  },
  confirmDialog: {
      show: false,
      title: null,
      text: null,
      closeCallback: function(){ },
      confirmCallback: function(){ }
  },
  snackbar: {
      enabled: false,
      type: "error",
      timeout: 60000,
      title: null,
      description: null               
  }     
}
